import { FC } from 'react'

import { PaginationNumber } from './components'

type Props = {
  enlargement?: number
  onPageChange: (page: number) => void
  pageCount: number
  selectedPage?: number
}

export const Pages: FC<Props> = ({ pageCount, selectedPage, onPageChange, enlargement = 1 }) => (
  <>
    {Array(...Array(pageCount)).map((_, index) => {
      const key = index + enlargement

      return selectedPage === key ? (
        <PaginationNumber key={key} value={key} active />
      ) : (
        <PaginationNumber key={key} onClick={() => onPageChange(key)} value={key} />
      )
    })}
  </>
)
